import _ from 'lodash';
import Modal from '../../_components/modal/modal.js';

import tpl from './confirm-modal.tpl.html';
import './confirm-modal.styles.less';

class ConfirmModal extends Modal {

	constructor (confirmText, title, okText, cancelText) {
		super(tpl, {
			title: title || 'Confirm',
			confirmText: confirmText,
			okText: okText,
			cancelText: cancelText
		});
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			btnOK: '.btn-ok',
			btnCancel: '.btn-cancel'
		});
	}

	render(data) {
		super.render(data);

		this.ui.btnOK.click(() => this.close(true));
		this.ui.btnCancel.click(() => this.close(false));
	}

	close(result) {
		this.ui.btnOK.off();
		this.ui.btnCancel.off();

		super.close(result);
	}

}

export default ConfirmModal;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/_modals/confirm-modal/confirm-modal.view.js